/* eslint-disable @typescript-eslint/no-explicit-any */

import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { Observable, Subject } from 'rxjs';
import { SettingsUtilsService } from '../settings-utils.service';

import {
  PortfolioEntity,
  PortfolioSetupService,
} from './portfolio-setup-service';
import { takeUntil, tap } from 'rxjs/operators';

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'app-portfolio-setup',
  templateUrl: './portfolio-setup.component.html',
  styleUrls: ['./portfolio-setup.component.scss'],
})
export class PortfolioSetupComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  portfolioName$: Observable<string>;
  selectedEntities$: Observable<PortfolioEntity[]>;
  items$: Observable<any>;
  loading$: Observable<boolean>;
  isValid$: Observable<boolean>;

  constructor(
    public dialog: MatDialog,
    private settingsUtils: SettingsUtilsService,
    public portfolioSetupService: PortfolioSetupService,
  ) {
    this.portfolioName$ = this.portfolioSetupService.portfolioName$;
    this.selectedEntities$ = this.portfolioSetupService.selectedEntities$;
    this.items$ = this.portfolioSetupService.items$;
    this.loading$ = this.portfolioSetupService.loading$;
    this.isValid$ = this.portfolioSetupService.isValid$();
  }

  ngOnInit() {
    this.portfolioSetupService.clearSelection();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onPortfolioNameChange(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    this.portfolioSetupService.setPortfolioName(inputElement.value);
  }

  optSelect(option: any): void {
    this.portfolioSetupService.addSelectedEntity(option);
  }

  removeEntity(id: string): void {
    this.portfolioSetupService.removeEntity(id);
  }
  createPortfolio(): void {
    this.portfolioSetupService
      .createPortfolio()
      .pipe(
        takeUntil(this.destroy$),
        tap({
          next: () => {
            this.portfolioSetupService.clearSelection();
            this.portfolioSetupService.setSetUpComplete(true);
            this.iClose();
          },
          error: (error) => {
            console.error('Portfolio creation failed:', error);
          },
        }),
      )
      .subscribe();
  }
  defaultPortfolio(): void {
    this.portfolioSetupService
      .defaultPortfolio()
      .pipe(
        takeUntil(this.destroy$),
        tap({
          next: () => {
            this.portfolioSetupService.setSetUpComplete(true);
            this.iClose();
          },
          error: (error) => {
            console.error('Portfolio creation failed:', error);
          },
        }),
      )
      .subscribe();
  }

  iClose() {
    this.dialog.closeAll();
  }

  iMatch(entity) {
    return this.settingsUtils.iMatch(entity);
  }

  numberFormat(num) {
    if (num === undefined || num === null) {
      return '';
    }
    return this.settingsUtils.numberFormat(num);
  }

  get searchFormControl() {
    return this.portfolioSetupService.searchFormControl;
  }
}
